import gql from 'graphql-tag'
import client from '@stores/apollo'
import { MoveOrder } from '@api/types'
import { MoveOrderFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createMoveOrder: {
    moveOrder: MoveOrder
  }
}

const mutateHandler = handleFetchResult<IPayload, MoveOrder>({
  handler: (data) => data.createMoveOrder.moveOrder,
  name: 'Move Order',
})

export default function seat(input: {
  assignmentPlanId: string
  employeeId: string
  fromSpaceId?: string | null
  moveType: 'move'
  toSpaceId: string | null
}): Promise<MoveOrder> {
  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation Seat($input: CreateMoveOrderInput!, $assignmentPlanId: ID) {
    createMoveOrder(input: $input) {
      moveOrder {
        ...MoveOrderFragment
      }
    }
  }
  ${MoveOrderFragment}
`
